import {postRequest} from '../libs/AxiosService.util';


export async function serviceGetAttendanceReport(params) {
    return await postRequest('attendance/report', params);
}
export async function serviceDownloadAttendanceReport(params) {
    return await postRequest('attendance/report/export', params);
}
export async function serviceGetShiftWiseReport(params) {
    return await postRequest('shifts/shiftWise/report', params);
}
export async function serviceGetMusterReport(params) {
    return await postRequest('attendance/muster/report', params);
}
export async function serviceDownloadMusterReport(params) {
    return await postRequest('attendance/muster/report/export', params);
}
export async function serviceDownloadShiftReport(params) {
    return await postRequest('shifts/shiftWise/report/export', params);
}
export async function serviceEmployeesPayslipReport(params) {
    return await postRequest('employees/payslips/export', params);
}